(function () {

    'use strict';

    angular.module('app').controller('AccountingSurchargeProfileDetailsController', AccountingSurchargeProfileDetailsController);

    AccountingSurchargeProfileDetailsController.$inject = [
        '$routeParams',
        '$window',
        'AccountingService',
        'toastr',
        '$location',
        'ClientService',
        'Carrier',
        'AccountingSurchargeProfileSurchargesTableService',
        'ConfirmationModalFactory',
        '$rootScope',
        '$q',
        'scrollToForm'
    ];

    function AccountingSurchargeProfileDetailsController(
        $routeParams,
        $window,
        AccountingService,
        toastr,
        $location,
        ClientService,
        Carrier,
        AccountingSurchargeProfileSurchargesTableService,
        ConfirmationModalFactory,
        $rootScope,
        $q,
        scrollToForm
    ) {

        const vm                = this;
        const newProfile        = "add";

        vm.id                   = $routeParams.id === newProfile ? null : $routeParams.id;
        vm.surchargesTable      = new AccountingSurchargeProfileSurchargesTableService();

        const viewConfirmation  = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const onRouteChange     = $rootScope.$on('$routeChangeStart', checkIfThereIsUnsavedData); 

        vm.onSelectCarrier      = onSelectCarrier;
        vm.back                 = back;
        vm.save                 = save;

        init();

        /**
         * @function    init
         * @description Initialize all the methods that needed to be run when the controller is initialized
         * 
         */
        function init() {
            vm.isFetching = true;
            $q.all([loadCarriersData()]).then(data => {
                loadSurchargeProfileProjectionData();
                vm.isFetching = false;
            });
        }
        
        /**
         * @function    loadSurchargeData
         * @description Get the surcharge profile data using the id passed in the url query parameter and use it to create a SurchargeProfilePayload object.
         *              If the id data is equal to null, initialize the SurchargeProfilePayload fields as null.
         *
         */
        function loadSurchargeProfileProjectionData(){
            if (vm.id) {
                AccountingService.SurchargeProfiles.getOne(data => {
                    initSurchargeProfileProjectionObject(data);
                }, (error) => {
                    toastr.error('Error', error.message);
                    $window.history.back();
                }, vm.id)
            } else {
                initSurchargeProfileProjectionObject({});
            }
        }

        /**
         * @function    initSurchargeProfileProjectionObject
         * @description Create a SurchargeProfileProjection object from the data passed in the data parameter
         *              If the parameter passed is an empty object initilize all the SurchargeProfileProjection object fields as null.
         * 
         * @param       { SurchargeProfileProjection Object } data 
         */
        function initSurchargeProfileProjectionObject(surchargeProfileProjectionData) {
            vm.surchargeProfileProjection = {
                carrierId       :surchargeProfileProjectionData.carrierId || null, 
                serviceId       :surchargeProfileProjectionData.serviceId, 
                company         :surchargeProfileProjectionData.company || null, 
                feeType         :surchargeProfileProjectionData.feeType || null, 
                id              :surchargeProfileProjectionData.id || null, 
                invoiceNumber   :surchargeProfileProjectionData.invoiceNumber || null, 
                name            :surchargeProfileProjectionData.name || null, 
                reseller        :surchargeProfileProjectionData.reseller || null, 
                serviceDetails  :surchargeProfileProjectionData.serviceDetails || null, 
                surcharges      :surchargeProfileProjectionData.surcharges || [], 
                customers       :surchargeProfileProjectionData.customers || []
            };

            vm.surchargeProfileProjection.carrier = surchargeProfileProjectionData.carrierId ? vm.carriers.find(item => item.id == surchargeProfileProjectionData.carrierId) : null;
            
            if(vm.surchargeProfileProjection.carrier) {
                onSelectCarrier(vm.surchargeProfileProjection.carrier);
            }

            vm.surchargeProfileProjection.service       = surchargeProfileProjectionData.serviceId ? vm.services.find(item => item.id == surchargeProfileProjectionData.serviceId) : null;
            vm.surchargeProfileProjection.accountNumber = surchargeProfileProjectionData.accountNumber || null, 
            vm.surchargeProfileProjectionRaw            = angular.copy(vm.surchargeProfileProjection);

            vm.surchargesTable.updateTableData(vm.surchargeProfileProjection.surcharges);
        }

        /**
         * @function    loadCarriersData
         * @description Load all carrier data. 
         * @note        There is no filters available in the api for this one 
         *              so filtering happens in the front-end side.
         * 
         * @return      promise object
         */
        function loadCarriersData(){
            const deffered = $q.defer(); 
            vm.isFetchingCarriersData = true;
            Carrier.getCarriers(data => {
                vm.carriers = data;
                vm.isFetchingCarriersData = false;
                deffered.resolve(data);
            }, error => {
                vm.isFetchingCarriersData = false;
                toastr.error('Error', error.message);
                deffered.reject(error);
            });
            return deffered.promise;
        }

        /**
         * @function    onSelectCarrier
         * @description This method will fire if a carrier has been selected in the dropdwon form.
         *
         * @param       { CarrierInformation Object } carrierInformationObject
         */
        function onSelectCarrier(carrierInformationObject){
            loadSelectedCarrierRelatedServices(carrierInformationObject);
            loadSelectedCarrierRelatedAccountNumbers(carrierInformationObject);
        }

        /**
         * @function    loadSelectedCarrierRelatedServices
         * @description Load services related to the carrier passed in the carrierInformationObject parameter.
         * 
         * @param       { CarrierInformation Object } carrierInformationObject
         */
        function loadSelectedCarrierRelatedServices(carrierInformationObject){
            const allServicesOption = {
                name :'All Services', 
                id   :null 
            }

            vm.surchargeProfileProjection.service = null; 
            vm.services = carrierInformationObject.services; 
            vm.services.unshift(allServicesOption);
        }

        /**
         * @function    loadSelectedCarrierRelatedAccountNumbers
         * @description Load account numbers related to the carrier passed in the carrierInformationObject parameter.
         * 
         * @param       { CarrierInformation Object } carrierInformationObject
         */
        function loadSelectedCarrierRelatedAccountNumbers(carrierInformationObject){
            vm.isFetchingAccountNumbers = true;
            vm.surchargeProfileProjection.accountNumber = null; 
            Carrier.getCarrierAccountNumbers(carrierInformationObject.id, (data) => {
                vm.accountNumbers = data;
                vm.isFetchingAccountNumbers = false;
            }, error => {
                vm.isFetchingAccountNumbers = false;
                toastr.error('Error', error.message);
            });
        }

        /**
         * @function    checkIfThereIsUnsavedData
         * @description Check if there is an unsaved data. 
         *              If there is an unsaved data this method will show a warning modal box that will ask the user if he/she wants to proceed. 
         *              If the user choose to proceed the unsaved data will be discarded otherwise the user will remain on the page. 
         * 
         * @param       {event Object} event 
         * @param       {route Object} next
         */
        function checkIfThereIsUnsavedData(event, next){
            if(!angular.equals(sanitizePayload(vm.surchargeProfileProjection), sanitizePayload(vm.surchargeProfileProjectionRaw))) {
                viewConfirmation.getInstance().result.then(cond => {
                    if(cond) {
                        onRouteChange(); 
                        let nextRoute = next.$$route.originalPath;
                        $location.path(nextRoute);
                    }
                });
                event.preventDefault();
            }
        }

        /**
         * @function    sanitizePayload
         * @description Create a SurchargeProfilePayload Object. 
         * 
         * @param       {SurchargeProfile Object} surchargeProfile
         * @return      {SurchargeProfilePayload Object}
         */
        function sanitizePayload(surchargeProfile){
            if(surchargeProfile) {
                const surchargeProfilePayloadObject = {
                    accountNumber   :surchargeProfile.accountNumber, 
                    carrierId       :angular.getObjVal(surchargeProfile, 'carrier.id') ? angular.getObjVal(surchargeProfile, 'carrier.id') : null, 
                    feeType         :"", 
                    name            :surchargeProfile.name, 
                    serviceId       :angular.getObjVal(surchargeProfile, 'service.id') ? angular.getObjVal(surchargeProfile, 'service.id') : null, 
                    surcharges      :surchargeProfile.surcharges.map(surcharge => {
                        return {
                            surchargeInternalName   :surcharge.surchargeInternalName,
                            priority                :surcharge.priority,
                            fee                     :surcharge.fee, 
                            margin                  :surcharge.margin,
                            marginValueType         :surcharge.marginValueType, 
                            feeValueType            :surcharge.feeValueType,
                            serviceCodeSurcharge    :surcharge.serviceCodeSurcharge
                        }
                    })
                }
                if(vm.id) {
                    surchargeProfilePayloadObject.id = surchargeProfile.id;
                }
                return surchargeProfilePayloadObject;
            }
        }

        /**
         * @function    back
         * @description Redirect back the user the surcharges list
         * 
         */
        function back(){
            $location.path('/accounting/surcharges');
        }

        /**
         * @function    save    
         * @description Create or Update surcharge profile data. 
         * 
         * @param       { form Object } form 
         */
        function save(form){
            if(!isPayloadDataValid(form)){
                return false;
            }

            vm.isSaveInProgress = true; 
            const payload       = sanitizePayload(vm.surchargeProfileProjection);

            if(vm.id) {
                AccountingService.SurchargeProfiles.update((data) => {
                    initSurchargeProfileProjectionObject(data); 
                    toastr.success('Success', 'Surcharge successfully updated!');
                    vm.isSaveInProgress = false;
                }, (error) => {
                    toastr.error('Error', error.message);
                    vm.isSaveInProgress = false;
                }, vm.id, payload);
            }
            else {
                AccountingService.SurchargeProfiles.create(function (data) {
                    vm.isSaveInProgress = false;
                    vm.surchargeProfileProjectionRaw = vm.surchargeProfileProjection;
                    $location.path('/accounting/surcharges/' + data.id);
                    toastr.success('Success', 'Surcharge successfully created!');
                }, function (error) {
                    vm.isSaveInProgress = false;
                    toastr.error(error.message || 'Please try again', 'Unable to save surcharge.');
                }, payload)
            }
        }

        /**
         * @function    isPayloadDataValid
         * @description Check if the form is valid and if the surcharges table has values. 
         *              If not return false otherwise return true.
         * 
         * @param       { form Object }form
         * @returns     { boolean }
         */
        function isPayloadDataValid(form){
            form.$setSubmitted(); 
            if(form.$invalid) {
                scrollToForm(form.$name);
                return false; 
            }
            if(vm.surchargeProfileProjection.surcharges.length == 0) {
                vm.hightLightTable = true;
                return false; 
            }
            vm.hightLightTable = false;
            return true;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingSurchargeProfileDetailsController.js